import { render, staticRenderFns } from "./PrintBill.vue?vue&type=template&id=5db24590&scoped=true&"
import script from "./PrintBill.vue?vue&type=script&lang=js&"
export * from "./PrintBill.vue?vue&type=script&lang=js&"
import style0 from "./PrintBill.vue?vue&type=style&index=0&id=5db24590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db24590",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VRow,VSelect})
